pageId = 'page-member-settings'
page = '#' + pageId

$ ->
  $(document)
  .on 'click', '.form-del-member-confirm .btn-cancel', (e) ->
    simple.dialog.removeAll()
  .on 'click', '.rebind-wechat-sheet .btn-cancel', (e) ->
    simple.dialog.removeAll()
  .on 'ajax:beforeSend', '.form-del-member-confirm', ->
    dialog = $(@).closest('.simple-dialog').data('dialog')
    dialog.el.hide() if dialog
    simple.loading
      type: 'global'
      msg: '正在退出团队...'

  .on 'ajax:success', '.form-del-member-confirm', delMemberSuccess
  .on 'ajax:success', "#{ page } .link-close-two-factor-auth", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  .on 'ajax:success', "#{ page } .link-clear-two-factor-trust", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  .on 'ajax:success', "#{ page } .settings-form", (e, result) ->
    return if e.currentTarget != e.target
    location.reload()

  .on 'ajax:success', "#{ page } .link-unbind-wechat", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  .on 'ajax:success', "#{ page } .link-unbind-wxwork", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  .on 'ajax:success', "#{ page } .link-unbind-feishu", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  .on 'ajax:success', "#{ page } .link-unbind-dingtalk", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  .on 'ajax:success', "#{ page } .link-unbind-shimo", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true

  tower.stack.on 'pageunload', (e, $page, pageParams) ->
    if $page.is(page)
      tower.tempPusherSocket.disconnect()  if !!tower.tempPusherSocket
      tower.tempPusherSocket = null


$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  initUploader($page)
  $('#btn-del-member').on 'click', ->
    if tower.me.owner
      simple.dialog.message
        content: $('#tpl-del-owner').html()
    else
      dialog = simple.dialog
        content: $('#tpl-del-member').html()
        width: 520
        modal: true
        buttons: null

  $('.link-bind-wechat').on 'click', bindWechat
  $('.link-open-tfa').on 'click', openTwoFactorAuth

uploader = undefined
initUploader = ($page) ->
  uploadBtn = $('.link-upload', $page)
  uploader = simple.uploader
    url: uploadBtn.data('url')
    params:
      conn_guid: $('#conn-guid').val()
      authenticity_token: $('meta[name=csrf-token]').attr('content')
    # TODO: disable OSS upload for avatar for now
    customXhr: false

  tower.connectUploader uploadBtn, uploader,
    title: '选择新头像'

  uploader.on 'beforeupload', (e, file) ->
    if $.inArray(file.ext, ['jpeg', 'jpg', 'png']) == -1
      simple.dialog.message content: '请选择 jpg 或者 png 文件'
      return false

    if file.size && file.size/1048576 > 5
      simple.dialog.message content: '请上传小于 5M 的头像文件。'
      return false

    $('.avatar-wrapper .loading').show()

  uploader.on 'uploadsuccess', (e, file, result) ->
    $('.avatar-wrapper img.avatar, .link-member-menu img.avatar')
      .attr 'src', result.avatar

  uploader.on 'uploaderror', (e, file, xhr, status) ->
    errorMsg = ''
    try
      result = JSON.parse(xhr.responseText)
      $.each result.errors, (i, err) ->
        errorMsg += err.msg + '<br/>'
    catch err
      errorMsg = '头像上传失败'
    simple.dialog.message content: errorMsg

  uploader.on 'uploadcomplete', (e, file, response) ->
    $('.avatar-wrapper .loading').hide()

  simple.filedrop(
    el: $page.find('.upload-avatar')
    hints: '拖拽到这里上传').on 'drop', (e, files) ->
    uploader.upload files[0]


delMemberSuccess =  (e, result)->
  simple.dialog.removeAll()
  simple.loading.destroy()

  if result.success
    window.location.href = result.target_url
  else if result.owner
    simple.dialog.message
      content: $('#tpl-del-owner').html()
  else
    $('#btn-del-member').trigger('click')
    $('#del-member-password').addClass('error').parent().after '<p class="error">密码错误</p>'
    dialog = $('.form-del-member-confirm').closest('.simple-dialog').data('dialog')
    dialog.refresh() if dialog


bindWechat = ->
  dialog = simple.dialog
    content: $('#tpl-bind-wechat').html()
    cls: 'dialog-bind-wechat'
    width: 400
    buttons: null

  dialog.el.find('.form-action-rebind').on 'ajax:success', (e, result) ->
    return unless result.success
    $suSheet = dialog.el.find('.success-sheet')
    $rebindWechatSheet = dialog.el.find('.rebind-wechat-sheet')
    $rebindWechatSheet.fadeOut 'fast', ->
      $suSheet.fadeIn 'fast'
      dialog.refresh()
      $('.form-item-wechat .status').addClass('enabled')
        .text("已绑定微信: #{ result.nickname }")
        .next('.link-bind-wechat').remove()

  $.ajax
    url: '/wechat/qrcode/?type=9'
    type: 'get'
    dataType: 'json'
    success: (result) ->
      return  unless result.success

      dialog.el.find('img.qrcode')
        .attr 'src', result.qrcode_url

      channel = tower.tempPusher(result.channel)
      channel.bind 'pusher:subscription_succeeded', ->
        $('.qrcode-wrap').removeClass('loading')
          .find('.indicator').remove()

      .bind 'WECHAT_ONLY_BIND', (result) ->
        $qrSheet = dialog.el.find('.qrcode-sheet')
        $suSheet = dialog.el.find('.success-sheet')
        $rebindWechatSheet = dialog.el.find('.rebind-wechat-sheet')
        if result.success
          $qrSheet.fadeOut 'fast', ->
            $suSheet.fadeIn 'fast'
            dialog.refresh()
            $('.form-item-wechat .status').addClass('enabled')
              .text("已绑定微信: #{ result.nickname }")
              .next('.link-bind-wechat').remove()
        else if !result.success && result.please_rebind
          $rebindWechatSheet.find('.error-desc').html(result.message)
          $rebindWechatSheet.find('.btn-action-rebind').val("解绑「#{result.previous_bind_email}」，并重新绑定到当前账号")
          $qrSheet.fadeOut 'fast', ->
            $rebindWechatSheet.fadeIn 'fast'
            dialog.refresh()
        else
          $qrSheet.find('.error').remove()
          $("<p class='error'>#{ result.message }</p>").appendTo $qrSheet
          dialog.refresh()

        tower.tempPusherSocket.disconnect()  if !!tower.tempPusherSocket
        tower.tempPusherSocket = null

openTwoFactorAuth = ->
  if $('#tpl-two-factor-auth-has-messages').val() == 'true'
    dialog = simple.dialog
      cls: 'dialog-tfa-message'
      content: $('#tpl-two-factor-auth').html()
    return false
  else
    return true
